export default {
    fetchUrl:
        process.env.NODE_ENV === "development" ?
            // "https://api.pzhappy.com" ||
            "http://127.0.0.1:7001"
            :
            process.env.NODE_ENV === "production" ? "https://api.pzhappy.com" : // https://www.mobi2077.com   http://8.210.139.154
                'http://107.148.53.226:7001',
};
